/* ============================================================
   L'La Pooche Dog Spa — in-place website editor
   Runs only when the owner is logged in to the dashboard and the
   editing service address is set in Theme settings. Click any text
   or photo on the page, change it, and it is saved to the live site.
   ============================================================ */
(function () {
  var cfg = window.LLP_CFG || {};
  if (cfg.design) return;
  var token;
  try { if (sessionStorage.getItem('llp_admin') !== '1') return; token = sessionStorage.getItem('llp_token'); } catch (e) { return; }
  var bar = document.getElementById('llpEditBar');
  var toggle = document.getElementById('llpEditToggle');
  if (!bar || !toggle) return;
  if (!cfg.endpoint || !token) {
    // The editing service is not connected yet (one-time setup), or this login was local-only.
    toggle.addEventListener('click', function () {
      var n = document.getElementById('llpEditNotice');
      if (!n) {
        n = document.createElement('div'); n.id = 'llpEditNotice'; n.className = 'llp-edit-toast is-err';
        n.textContent = cfg.endpoint
          ? 'Please log out of the dashboard and log in again, then try Edit this page.'
          : 'Editing is not switched on yet: the one-time setup of the editing service has not been finished.';
        document.body.appendChild(n);
      }
      n.hidden = false; clearTimeout(n._t); n._t = setTimeout(function () { n.hidden = true; }, 5000);
    });
    return;
  }

  var editing = false;
  var busy = false;
  var template = cfg.template || 'index';

  /* ---------- tiny UI helpers ---------- */
  var toastEl = document.createElement('div');
  toastEl.className = 'llp-edit-toast'; toastEl.hidden = true; document.body.appendChild(toastEl);
  var toastT;
  function toast(msg, kind) {
    toastEl.textContent = msg; toastEl.className = 'llp-edit-toast' + (kind ? ' is-' + kind : ''); toastEl.hidden = false;
    clearTimeout(toastT); if (kind !== 'busy') toastT = setTimeout(function () { toastEl.hidden = true; }, 2600);
  }
  function api(payload, file) {
    var opts = { method: 'POST' };
    payload.token = token;
    if (file) { var fd = new FormData(); fd.append('json', JSON.stringify(payload)); fd.append('file', file, file.name); opts.body = fd; }
    else { opts.headers = { 'Content-Type': 'text/plain' }; opts.body = JSON.stringify(payload); }
    return fetch(cfg.endpoint, opts).then(function (r) { return r.json(); }).then(function (d) {
      if (!d.ok) {
        if (/log in again/i.test(d.error || '')) { try { sessionStorage.removeItem('llp_token'); } catch (e) {} }
        throw new Error(d.error || 'Something went wrong.');
      }
      return d;
    });
  }
  function ctx(el) {
    var section = el.closest('[data-llp-section]');
    return {
      template: template,
      sectionId: section ? section.getAttribute('data-llp-section').replace(/^template--\d+__/, '') : null,
      blockId: el.getAttribute('data-llp-block') || null,
      settingId: el.getAttribute('data-llp-edit'),
      type: el.getAttribute('data-llp-type') || 'text',
    };
  }

  /* ---------- edit mode on/off ---------- */
  function setEditing(on) {
    editing = on;
    document.body.classList.toggle('llp-editing', on);
    toggle.textContent = on ? 'Done editing' : 'Edit this page';
    toggle.classList.toggle('is-on', on);
    if (on) { decorate(); toast('Edit mode: click any words or photo to change them.', 'ok'); }
    else { undecorate(); }
    try { sessionStorage.setItem('llp_editing', on ? '1' : '0'); } catch (e) {}
  }
  toggle.addEventListener('click', function () { if (!busy) setEditing(!editing); });
  try { if (sessionStorage.getItem('llp_editing') === '1') setEditing(true); } catch (e) {}

  /* ---------- block controls (delete / move) and add buttons ---------- */
  function decorate() {
    document.querySelectorAll('[data-llp-blockroot]').forEach(function (root) {
      if (root.querySelector(':scope > .llp-edit-tools')) return;
      if (getComputedStyle(root).position === 'static') root.style.position = 'relative';
      var tools = document.createElement('div');
      tools.className = 'llp-edit-tools';
      tools.innerHTML =
        '<button type="button" data-act="up" title="Move earlier">&#8249;</button>' +
        '<button type="button" data-act="down" title="Move later">&#8250;</button>' +
        '<button type="button" data-act="del" title="Remove this ' + (root.getAttribute('data-llp-blockname') || 'item') + '">&times;</button>';
      root.appendChild(tools);
    });
    document.querySelectorAll('[data-llp-add]').forEach(function (section) {
      if (section.querySelector(':scope .llp-edit-add')) return;
      var wrap = section.querySelector('.llp-wrap') || section;
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'llp-edit-add';
      btn.textContent = '+ ' + (section.getAttribute('data-llp-add-label') || 'Add');
      wrap.appendChild(btn);
    });
  }
  function undecorate() {
    document.querySelectorAll('.llp-edit-tools, .llp-edit-add, .llp-edit-toolbar').forEach(function (el) { el.remove(); });
    document.querySelectorAll('[contenteditable="true"]').forEach(function (el) { el.removeAttribute('contenteditable'); });
  }

  /* ---------- click handling ---------- */
  document.addEventListener('click', function (e) {
    if (!editing || busy) return;
    var tool = e.target.closest('.llp-edit-tools button');
    if (tool) { e.preventDefault(); e.stopPropagation(); blockAction(tool.closest('[data-llp-blockroot]'), tool.getAttribute('data-act')); return; }
    var add = e.target.closest('.llp-edit-add');
    if (add) { e.preventDefault(); addBlocks(add.closest('[data-llp-add]')); return; }
    if (e.target.closest('.llp-edit-toolbar') || e.target.closest('#llpEditBar')) return;
    var el = e.target.closest('[data-llp-edit]');
    if (!el) return;
    if (el.getAttribute('contenteditable') === 'true') return; // already editing this one
    e.preventDefault(); e.stopPropagation();
    var type = el.getAttribute('data-llp-type') || 'text';
    if (type === 'image') pickImage(el);
    else if (type === 'richtext') editRich(el);
    else editText(el, type);
  }, true);

  /* ---------- plain text ---------- */
  function editText(el, type) {
    var original = el.innerHTML;
    el.setAttribute('contenteditable', 'true');
    el.classList.add('llp-edit-active');
    el.focus();
    placeCaretAtEnd(el);
    function finish(save) {
      el.removeAttribute('contenteditable'); el.classList.remove('llp-edit-active');
      el.removeEventListener('blur', onBlur); el.removeEventListener('keydown', onKey);
      if (!save) { el.innerHTML = original; return; }
      var value = el.innerText.replace(/ /g, ' ');
      value = type === 'textarea' ? value.replace(/\n{3,}/g, '\n\n').trim() : value.replace(/\s+/g, ' ').trim();
      if (value === htmlToText(original, type)) return;
      var c = ctx(el);
      save_(c, value).then(function () {
        if (type === 'textarea') el.innerHTML = escapeHtml(value).replace(/\n/g, '<br>'); else el.textContent = value;
      }).catch(function (err) { el.innerHTML = original; toast(err.message, 'err'); });
    }
    function onBlur() { finish(true); }
    function onKey(ev) {
      if (ev.key === 'Escape') { ev.preventDefault(); finish(false); }
      if (ev.key === 'Enter' && type !== 'textarea') { ev.preventDefault(); el.blur(); }
    }
    el.addEventListener('blur', onBlur); el.addEventListener('keydown', onKey);
  }
  function htmlToText(html, type) {
    var d = document.createElement('div'); d.innerHTML = html;
    var t = d.innerText.replace(/ /g, ' ');
    return type === 'textarea' ? t.replace(/\n{3,}/g, '\n\n').trim() : t.replace(/\s+/g, ' ').trim();
  }

  /* ---------- rich text (bio, policy, intro) ---------- */
  function editRich(el) {
    var original = el.innerHTML;
    el.setAttribute('contenteditable', 'true');
    el.classList.add('llp-edit-active');
    var tb = document.createElement('div');
    tb.className = 'llp-edit-toolbar';
    tb.innerHTML =
      '<button type="button" data-cmd="bold"><b>B</b></button>' +
      '<button type="button" data-cmd="italic"><i>I</i></button>' +
      '<button type="button" data-cmd="insertUnorderedList">&#8226; List</button>' +
      '<button type="button" data-cmd="formatBlock" data-arg="p">Paragraph</button>' +
      '<span class="llp-edit-toolbar__gap"></span>' +
      '<button type="button" data-cmd="cancel">Cancel</button>' +
      '<button type="button" class="is-primary" data-cmd="save">Save</button>';
    el.parentNode.insertBefore(tb, el);
    el.focus();
    tb.addEventListener('mousedown', function (ev) { ev.preventDefault(); }); // keep the selection
    tb.addEventListener('click', function (ev) {
      var b = ev.target.closest('button'); if (!b) return;
      var cmd = b.getAttribute('data-cmd');
      if (cmd === 'save') {
        var html = el.innerHTML;
        tb.remove(); el.removeAttribute('contenteditable'); el.classList.remove('llp-edit-active');
        save_(ctx(el), html).then(function (d) { if (d && d.value) el.innerHTML = d.value; })
          .catch(function (err) { el.innerHTML = original; toast(err.message, 'err'); });
      } else if (cmd === 'cancel') {
        tb.remove(); el.removeAttribute('contenteditable'); el.classList.remove('llp-edit-active'); el.innerHTML = original;
      } else {
        document.execCommand(cmd, false, b.getAttribute('data-arg') || null);
      }
    });
  }

  /* ---------- photos ---------- */
  function pickImage(el) {
    var input = document.createElement('input');
    input.type = 'file'; input.accept = 'image/*';
    input.addEventListener('change', function () {
      var f = input.files && input.files[0]; if (!f) return;
      busy = true; el.classList.add('llp-edit-uploading'); toast('Uploading photo…', 'busy');
      shrink(f).then(function (blob) { return api({ action: 'upload_image' }, blob); })
        .then(function (up) {
          var c = ctx(el); c.type = 'image';
          return save_(c, up.value, true).then(function () {
            var img = el.tagName === 'IMG' ? el : el.querySelector('img');
            if (img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = up.url; }
            else { el.innerHTML = '<img src="' + up.url + '" alt="">'; }
            if (el.hasAttribute('data-llp-full')) el.setAttribute('data-llp-full', up.url);
            toast('Photo saved.', 'ok');
          });
        })
        .catch(function (err) { toast(err.message, 'err'); })
        .then(function () { busy = false; el.classList.remove('llp-edit-uploading'); });
    });
    input.click();
  }
  function shrink(file) {
    // Resize big photos before upload (max 1800px, JPEG). Falls back to the original file.
    return new Promise(function (resolve) {
      if (!/^image\/(jpeg|png|webp|heic|heif)/i.test(file.type) || file.size < 400 * 1024) return resolve(file);
      var url = URL.createObjectURL(file);
      var im = new Image();
      im.onload = function () {
        var max = 1800, w = im.naturalWidth, h = im.naturalHeight;
        var scale = Math.min(1, max / Math.max(w, h));
        var cv = document.createElement('canvas'); cv.width = Math.round(w * scale); cv.height = Math.round(h * scale);
        cv.getContext('2d').drawImage(im, 0, 0, cv.width, cv.height);
        cv.toBlob(function (b) {
          URL.revokeObjectURL(url);
          if (!b) return resolve(file);
          var name = (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg';
          resolve(new File([b], name, { type: 'image/jpeg' }));
        }, 'image/jpeg', 0.86);
      };
      im.onerror = function () { URL.revokeObjectURL(url); resolve(file); };
      im.src = url;
    });
  }

  /* ---------- add / remove / move blocks ---------- */
  function addBlocks(section) {
    var sectionId = section.getAttribute('data-llp-section').replace(/^template--\d+__/, '');
    var blockType = section.getAttribute('data-llp-add');
    var imageKey = section.getAttribute('data-llp-add-image');
    var defaults = {};
    try { defaults = JSON.parse(section.getAttribute('data-llp-add-defaults') || '{}'); } catch (e) {}
    if (!imageKey) {
      busy = true; toast('Adding…', 'busy');
      api({ action: 'add_block', template: template, sectionId: sectionId, blockType: blockType, settings: defaults })
        .then(function () { toast('Added. Refreshing…', 'ok'); setTimeout(function () { location.reload(); }, 600); })
        .catch(function (err) { busy = false; toast(err.message, 'err'); });
      return;
    }
    var input = document.createElement('input');
    input.type = 'file'; input.accept = 'image/*';
    if (section.getAttribute('data-llp-add-multi') === 'true') input.multiple = true;
    input.addEventListener('change', function () {
      var files = Array.prototype.slice.call(input.files || []); if (!files.length) return;
      busy = true;
      var i = 0;
      function next() {
        if (i >= files.length) { toast('Done. Refreshing…', 'ok'); setTimeout(function () { location.reload(); }, 600); return; }
        toast('Uploading photo ' + (i + 1) + ' of ' + files.length + '…', 'busy');
        var f = files[i++];
        shrink(f).then(function (blob) { return api({ action: 'upload_image' }, blob); })
          .then(function (up) {
            var settings = {}; for (var k in defaults) settings[k] = defaults[k];
            settings[imageKey] = up.value;
            return api({ action: 'add_block', template: template, sectionId: sectionId, blockType: blockType, settings: settings });
          })
          .then(next)
          .catch(function (err) { busy = false; toast(err.message, 'err'); });
      }
      next();
    });
    input.click();
  }
  function blockAction(root, act) {
    var blockId = root.getAttribute('data-llp-blockroot');
    var section = root.closest('[data-llp-section]');
    var sectionId = section && section.getAttribute('data-llp-section').replace(/^template--\d+__/, '');
    if (act === 'del') {
      if (!confirm('Remove this ' + (root.getAttribute('data-llp-blockname') || 'item') + ' from the website?')) return;
      busy = true; toast('Removing…', 'busy');
      api({ action: 'remove_block', template: template, sectionId: sectionId, blockId: blockId })
        .then(function () { root.remove(); toast('Removed.', 'ok'); })
        .catch(function (err) { toast(err.message, 'err'); })
        .then(function () { busy = false; });
      return;
    }
    var dir = act === 'up' ? 'up' : 'down';
    busy = true; toast('Moving…', 'busy');
    api({ action: 'move_block', template: template, sectionId: sectionId, blockId: blockId, direction: dir })
      .then(function () {
        var sib = dir === 'up' ? root.previousElementSibling : root.nextElementSibling;
        if (sib && sib.hasAttribute('data-llp-blockroot')) {
          if (dir === 'up') sib.parentNode.insertBefore(root, sib); else sib.parentNode.insertBefore(sib, root);
        }
        toast('Moved.', 'ok');
      })
      .catch(function (err) { toast(err.message, 'err'); })
      .then(function () { busy = false; });
  }

  /* ---------- save ---------- */
  function save_(c, value, quiet) {
    if (!c.sectionId || !c.settingId) return Promise.reject(new Error('This item cannot be edited here.'));
    busy = true; if (!quiet) toast('Saving…', 'busy');
    return api({ action: 'set_setting', template: c.template, sectionId: c.sectionId, blockId: c.blockId, settingId: c.settingId, type: c.type, value: value })
      .then(function (d) { busy = false; if (!quiet) toast('Saved.', 'ok'); return d; })
      .catch(function (err) { busy = false; throw err; });
  }

  /* ---------- utils ---------- */
  function placeCaretAtEnd(el) {
    try { var r = document.createRange(); r.selectNodeContents(el); r.collapse(false); var s = window.getSelection(); s.removeAllRanges(); s.addRange(r); } catch (e) {}
  }
  function escapeHtml(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
})();
